import {
  FC,
  createContext,
  useContext,
  useMemo,
  useState,
  Dispatch,
  SetStateAction,
  PropsWithChildren
} from 'react'

export enum Step {
  ConfirmEditingStep,
  UploadIdCardStep,
  OcrFailedStep,
  OcrSucceededStep,
  EditManuallyStep,
  AddWorkPermitStep
}

interface StepsContextValue {
  step: Step
  setStep: Dispatch<SetStateAction<Step>>
}

const StepContext = createContext<StepsContextValue>({
  step: Step.ConfirmEditingStep,
  setStep: () => {}
})

export function useStep() {
  return useContext(StepContext)
}

export const StepProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState<Step>(Step.ConfirmEditingStep)

  const context = useMemo(
    (): StepsContextValue => ({ step: currentStep, setStep: setCurrentStep }),
    [currentStep]
  )

  return <StepContext.Provider value={context}>{children}</StepContext.Provider>
}
